import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cc4b2a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-banner-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy-background-modal-banner" }, null, -1))
const _hoisted_3 = { class: "modal-dialog-banner" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(['modal-banner', 'show', _ctx.modalOptions.classNameHeader])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.modalOptions?.actionClose)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "icon-close",
                src: require('../../assets/img/close-banner-icon.svg'),
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            class: "banner-image",
            src: _ctx.modalOptions?.image,
            onError: _cache[1] || (_cache[1] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args))),
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.openUrl(_ctx.modalOptions?.url)))
          }, null, 40, _hoisted_6)
        ])
      ])
    ], 2)
  ]))
}